module.exports = __webpack_public_path__ + "static/img/11.ed37b59.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/11.png
// module id = qSSc
// module chunks = 0